/* @flow */

import type { State } from 'src/shared/core/type/reduxTypes';

const slice = (state: State) => state.ui.nav;

export function selectMobileNavIsRegistered(state: State): boolean {
  return slice(state).withMobileNav;
}
